import script from "./AdmCursosView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdmCursosView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__